import React from "react";

const UserView = () => {
  return <div>UserView</div>;
};

export default UserView;
